import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { eUserType } from '@app/shared/enum/user-type';

@Injectable({
  providedIn: 'root'
})
export class ShipperGuard implements CanActivate {
  constructor(private _localStorageService: LocalStorageService,
    private _router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      if (this._localStorageService.getValueByKey('userType') ==  String(eUserType.SHIPPER) ||
      this._localStorageService.getValueByKey('userType') == String(eUserType.BRANCH_ADMIN) ||
      this._localStorageService.getValueByKey('userType') == String(eUserType.FINANCIAL_ADMIN) ||
      this._localStorageService.getValueByKey('userType') == String(eUserType.STAFF) ) {
        return true;
      } else {
        this._router.navigate(['account/login']);
        return false;

      }
    }
}
